import AppAdapter from 'adapters/app';

class PayoutAdapter extends AppAdapter {
  constructor(props) {
    super(props)
  }

	static providerId = '';
	static action = '';

}

export default PayoutAdapter;